
    import { ValidationProvider } from 'vee-validate';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faCheckSquare as fasCheckSquare,
    } from '@fortawesome/pro-solid-svg-icons/faCheckSquare';
    import {
        faCopy as farCopy,
    } from '@fortawesome/pro-regular-svg-icons/faCopy';

    import {
        faCheckSquare as farCheckSquare,
    } from '@fortawesome/pro-regular-svg-icons/faCheckSquare';

    import {
        faSquare as falSquare,
    } from '@fortawesome/pro-regular-svg-icons/faSquare';

    import C1Label from '@/C1Components/C1Label';
    import C1FormInput from '@/C1Components/C1FormInput';
    import C1FormTextarea from '@/C1Components/C1FormTextarea';
    import C1HelpText from '@/C1Components/C1HelpText';
    import C1Dropdown from '@/C1Components/C1Dropdown';

    export default {
        components: {
            ValidationProvider,
            C1FormInput,
            C1Label,
            C1FormTextarea,
            C1HelpText,
            C1Dropdown,
            FontAwesomeIcon,
        },

        filters: {
            errorMsg(value, questionId) {
                if (!value) { return ''; }
                return value.replace(`The ${questionId}`, 'This');
            },
        },

        props: {
            question: {
                type: Object,
                default: () => { return {}; },
            },

            scope: {
                type: String,
                default: '',
            },
        },

        data() {
            return {
                icons: {
                    fasCheckSquare,
                    farCopy,
                    farCheckSquare,
                    falSquare,
                },
            };
        },

        computed: {
            label() {
                let output = this.question.label;
                if (this.question.is_mandatory) {
                    output += ' <span class="text-danger">*</span>';
                }

                return output;
            },

            validationRules() {
                return this.question.validation_rules;
            },
        },

        watch: {
            answer: {
                handler() {
                    this.$emit('answer', {
                        question: this.question,
                        answer: this.answer,
                    });
                },
                deep: true,
            },
        },

        methods: {
            getStringAnswer() {
                if (typeof this.question.answer === 'object' && this.question.answer !== null) {
                    this.answer = this.question.answer.value;
                }
            },

            getObjectAnswer() {
                if (typeof this.question.answer === 'object' && this.question.answer !== null) {
                    this.answer = { id: parseInt(this.question.answer.value), label: '' };
                }
            },

            getArrayAnswer() {
                if (Array.isArray(this.question.answer) && this.question.answer.length) {
                    this.answer = this.question.answer.map((o) => {
                        return {
                            id: parseInt(o.value),
                            label: '',
                        };
                    });
                }
            },
        },
    };
